export default class ServicoDetailsController {
  constructor($q, $state, $scope, AuthenticationService, UIService, ServicoService, Servico, ServicoParticipante, ServicoInstituicao, ServicoAreaInterdisciplinar, EntidadeFinanciadora, Investigador, Instituicao, AreaInterdisciplinar, Setor, Impacto, ImpactoOds, Ods, Pais) {
    this.$q = $q;
    this.$state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.ServicoService = ServicoService;
    this.loaded = false;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.Servico = Servico;
    this.ServicoParticipante = ServicoParticipante;
    this.ServicoInstituicao = ServicoInstituicao;
    this.ServicoAreaInterdisciplinar = ServicoAreaInterdisciplinar;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Investigador = Investigador;
    this.Instituicao = Instituicao;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Setor = Setor;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.Pais = Pais;
    this.showEstadosPanel = false;

    this.loaded = false;

    // Default opt state - populate later when we have all states
    this.optParticipante = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.participantes = null;
    this.participantesLoading = true;

    // Default opt state - populate later when we have all states
    this.optAreas = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.areas = null;
    this.areasLoading = true;

    // Default opt state - populate later when we have all states
    this.optInstituicao = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.instituicoes = null;
    this.instituicoesLoading = true;

    // Default opt state - populate later when we have all states
    this.optImpactosOds = {
      total: 0,
      start: 0,
      end: 0,
      page: 1,
      items: 3,
      order: "id",
      sort: "desc",
      filter: {},
      filterLayout: {}
    };
    this.impactosOds = null;
    this.impactosOdsLoading = true;

    this.id = $state.params.id;

    this.loadData();
    this.limit = 3;
  }

  limitTo = () => {
    if (angular.isDefined(this.limit)) {
      this.limit = undefined;
    } else {
      this.limit = 3;
    }
  };

  loadData = () => {
    this.loaded = false;
    this.Servico.findOne({
      filter: {
        where: {
          id: this.id
        },
        include: ['criadoPor', 'atualizadoPor', 'entidadeFinanciadora', 'investigador', 'setor', 'impacto', {
          relation: 'participantes',
          scope: {
            include: {
              relation: 'investigador',
              scope: {
                fields: {userId: true}
              }
            }
          }
        }]
      }
    }).$promise.then(res => {
      this.data = res;

      this.getImpactosOdsForImpacto(); // We can only load this after getting impactoId
      this.getParticipantesForServico();
      this.getAreasForServico();
      this.getInstituicoesForServico();

      this.loaded = true;
    }).catch((error) => {
      console.log(error);
      this.$state.go('app.servico.list');
      this.UI.addToast('Erro ao carregar serviço. Verifique a ligação');
    });
  };

  editDetalhes = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      this.EntidadeFinanciadora.find({}).$promise.then(entidadesFinanciadoras => {
        this.Setor.find({}).$promise.then((setores) => {
            wait.close();
            let options = {
              size: 'lg',
              template: require('./details.dialog.html'),
              controller: ['$scope', ($scope) => {
                $scope.label = "Editar Serviço";
                $scope.servico = angular.copy(this.data);
                $scope.investigadores = investigadores;
                $scope.entidadesFinanciadoras = entidadesFinanciadoras;
                $scope.setores = setores;
                $scope.simnao = this.simnao;

                $scope.dateOptions = {
                  dataInicio: {format: 'DD/MM/YYYY'},
                  dataFim: {format: 'DD/MM/YYYY'}
                };

                $scope.auxEntidadeFinanciadora = {
                  selected: $scope.servico.entidadeFinanciadora ? $scope.servico.entidadeFinanciadora : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxSetor = {
                  selected: $scope.servico.setor ? $scope.servico.setor : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxInvestigador = {
                  selected: $scope.servico.investigador ? $scope.servico.investigador : null,
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxCoordenacao = {
                  selected: $scope.servico.coordenacao ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };
                $scope.auxAdoption = {
                  selected: $scope.servico.commercialAdoptions ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
                  infiniteScroll: {numToAdd: 20, currentItems: 20}
                };


                // Infinite Scroll magic
                $scope.addMoreItems = (infiniteScroll) => {
                  infiniteScroll.currentItems += infiniteScroll.numToAdd;
                };

                $scope.ok = () => {
                  $scope.$close($scope);
                };

                $scope.cancel = () => $scope.$dismiss('cancel');
              }]
            };

            this.UI.showDialog(options).then(res => {
              this.loaded = false;
              if (res) {
                this.data.dataInicio = res.servico.dataInicio.format();
                this.data.dataFim = res.servico.dataFim.format();
                this.data.acronimo = res.servico.acronimo;
                this.data.titulo = res.servico.titulo;
                this.data.financiamento = res.servico.financiamento;

                this.data.investigador = res.auxInvestigador.selected;
                this.data.investigadorId = res.auxInvestigador.selected.id;
                this.data.entidadeFinanciadora = res.auxEntidadeFinanciadora.selected;
                this.data.entidadeFinanciadoraId = res.auxEntidadeFinanciadora.selected.id;
                this.data.setor = res.auxSetor.selected;
                this.data.setorId = res.auxSetor.selected.id;

                this.data.coordenacao = res.auxCoordenacao.selected.value;
                this.data.commercialAdoptions = res.auxAdoption.selected.value;

                this.data.atualizadoPorId = this.user.id;
                this.data.atualizadoa = moment().format();

                this.Servico.upsert(this.data).$promise.then((res) => {
                  this.UI.addToast("Dados atualizados com sucesso");
                  this.loadData();
                }).catch((error) => {
                  console.log(error);
                  this.UI.showAlert("Erro ao atualizar servico. Verifique a ligação");
                  this.loaded = true;
                });
              }
            });
        }).catch((error) => {
          wait.close();
          console.log(error);
          this.UI.addToast("Não foi possível ler Setores. Verifique a ligação");
        });
      }).catch((error) => {
        wait.close();
        console.log(error);
        this.UI.addToast("Não foi possível ler Entidades. Verifique a ligação");
      });
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Investigadores. Verifique a ligação");
    });
  };

  // Edit yes/no with extra data
  editInformacao = () => {
    let options = {
      size: 'lg',
      template: require('./informacao.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Informação Adicional";
        $scope.servico = angular.copy(this.data);
        $scope.simnao = this.simnao;

        $scope.auxIncludeDiscussion = {
          selected: $scope.servico.includeDiscussion ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxInvolvingCivilSociety = {
          selected: $scope.servico.involvingCivilSociety ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxPromotingTeamBuilding = {
          selected: $scope.servico.promotingTeamBuilding ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(res => {
      this.loaded = false;
      if (res) {
        // Update bool values
        this.data.includeDiscussion = res.auxIncludeDiscussion.selected.value;
        this.data.involvingCivilSociety = res.auxInvolvingCivilSociety.selected.value;
        this.data.promotingTeamBuilding = res.auxPromotingTeamBuilding.selected.value;
        // Remove text if bool values are false
        if (!this.data.includeDiscussion) this.data.includeDiscussionText = null;
        else this.data.includeDiscussionText = res.servico.includeDiscussionText;
        if (!this.data.involvingCivilSociety) this.data.involvingCivilSocietyText = null;
        else this.data.involvingCivilSocietyText = res.servico.involvingCivilSocietyText;
        if (!this.data.promotingTeamBuilding) this.data.promotingTeamBuildingText = null;
        else this.data.promotingTeamBuildingText = res.servico.promotingTeamBuildingText;

        this.data.atualizadoPorId = this.user.id;
        this.data.atualizadoa = moment().format();

        this.Servico.upsert(this.data).$promise.then((res) => {
          this.UI.addToast("Dados atualizados com sucesso");
          this.loadData();
        }).catch((error) => {
          console.log(error);
          this.UI.showAlert("Erro ao atualizar servico. Verifique a ligação");
          this.loaded = true;
        });
      }
    });
  };

  editObservacoes = () => {
    let options = {
      size: 'lg',
      template: require('./observacoes.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Observações";
        $scope.observacoes = angular.copy(this.data.observacoes);

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;
      if (ok.observacoes !== 0 && !ok.observacoes)
        ok.observacoes = null;
      this.data.observacoes = ok.observacoes;
      this.data.atualizadoPorId = this.user.id;
      this.data.atualizadoa = moment().format();
      this.Servico.upsert(this.data).$promise.then((res) => {
        this.UI.addToast("Observações atualizadas com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar servico. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  // Multiple data
  // Participante
  participanteModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let participante = {};
    let auxInvestigadorSelection = undefined;
    if (edit && data != null) {
      participante = angular.copy(data);
      auxInvestigadorSelection = participante.investigador;
    }
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.participante.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Participante";
          scope.participante = participante;
          scope.investigadores = investigadores;

          scope.auxInvestigador = {
            selected: auxInvestigadorSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo participante para servico
  addParticipante = () => {
    this.participanteModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.participante) {
          this.participantesLoading = true;
          let item = angular.copy(ok.participante);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);
          // Check if participante is already there before creating
          this.ServicoService.usedPartialDataForModel({servicoId: this.id, investigadorId: item.investigadorId}, this.ServicoParticipante).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Participante já existe");
              this.participantesLoading = false;
            } else { // Create it
              this.ServicoService.createMultipleData(this.ServicoParticipante, [item], this.id, 'servicoId').then((x) => {
                this.UI.addToast("Participante adicionado com sucesso");
                this.getParticipantesForServico();
              }).catch(error => {
                this.participantesLoading = false;
                this.UI.addToast("Erro ao inserir participante. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.participantesLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete participante
  confirmDeleteParticipante = (x) => {
    let title = "Eliminar Participante";
    let warning = "Tem a certeza que pretende remover este participante?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeParticipante(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeParticipante = (x) => {
    this.participantesLoading = true;
    // Find again participante to delete so we can update it
    this.ServicoParticipante.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((participanteToRemove) => {

      // Remove data
      this.ServicoParticipante.deleteById({
        id: participanteToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Participante removido com sucesso");
        this.getParticipantesForServico();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar participante. Verifique se ainda existe.");
      this.getParticipantesForServico();
    });
  };

  getParticipantesForServico = () => {
    this.participantesLoading = true;
    let whereLiteral = {
      'ServicoParticipante.servicoId': this.id
    };
    let where = {};
    Object.keys(this.optParticipante.filter).forEach(f => {
      if (this.optParticipante.filter[f])
        where[f] = this.optParticipante.filter[f];
    });
    this.ServicoParticipante.table({
      params: {
        fields: [
          'ServicoParticipante.id as id',
          'ServicoParticipante.servicoId as servicoId',
          'ServicoParticipante.investigadorId as investigadorId',
          'ServicoParticipante.dataCriacao as dataCriacao',
          'ServicoParticipante.atualizadoa as atualizadoa',
          'ServicoParticipante.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Investigador.id as auxInvestigadorId',
          'Investigador.nome as auxInvestigadorNome'
        ],
        from: ['ServicoParticipante', 'User', 'User', 'Investigador'],
        references: [undefined, 'ServicoParticipante.criadoPorId', 'ServicoParticipante.atualizadoPorId', 'ServicoParticipante.investigadorId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optParticipante.order,
        sort: this.optParticipante.sort,
        limit: this.optParticipante.items,
        skip: (this.optParticipante.page - 1) * this.optParticipante.items,
      }
    }).$promise.then(res => {
      let page = this.optParticipante.page;
      let items = this.optParticipante.items;

      let total = res.count;

      this.optParticipante.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optParticipante.start - 1 + items) >= total) {
        this.optParticipante.end = total;
      } else {
        this.optParticipante.end = Number.parseInt(this.optParticipante.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.investigador = {
          id: x.auxInvestigadorId,
          nome: x.auxInvestigadorNome
        };
      });

      this.participantes = res.data;
      this.optParticipante.total = total;
      this.participantesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler participantes. Verifique a ligação");
    });
  };

  participanteSort = keyname => {
    if (this.optParticipante.order === keyname)
      this.optParticipante.page = 1;
    this.optParticipante.order = keyname;
    this.optParticipante.sort = this.optParticipante.sort === 'asc' ? 'desc' : 'asc';
    this.getParticipantesForServico();
  };

  participanteItem = val => {
    this.optParticipante.items = val;
    this.optParticipante.page = 1;
    this.getParticipantesForServico();
  };

  participantePage = sum => {
    this.optParticipante.page += sum;
    if (this.optParticipante.page < 1)
      this.optParticipante.page = 1;
    if (this.optParticipante.page > Math.ceil(this.optParticipante.total / this.optParticipante.items))
      this.optParticipante.page = Math.ceil(this.optParticipante.total / this.optParticipante.items);
    this.getParticipantesForServico();
  };

  viewParticipante = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./participante.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Área Interdisciplinar
  areasModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let area = {};
    let auxAreaSelection = undefined;
    if (edit && data != null) {
      area = angular.copy(data);
      auxAreaSelection = area.area;
    }
    let wait = this.UI.showWaiting();
    this.AreaInterdisciplinar.find({}).$promise.then((areas) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.area.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Área Interdisciplinar";
          scope.area = area;
          scope.areas = areas;

          scope.auxArea = {
            selected: auxAreaSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler áreas interdisciplinares. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova área para orientação
  addArea = () => {
    if (this.areas.length >= 3) {
      this.UI.addToast("Só é possível escolher até 3 áreas");
      return;
    }
    this.areasModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxArea && ok.area) {
          this.areasLoading = true;
          let item = angular.copy(ok.area);
          item.areaId = ok.auxArea.selected.id;
          item.area = angular.copy(ok.auxArea.selected);
          // Check if area is already there before creating
          this.ServicoService.usedPartialDataForModel({servicoId: this.id, areaId: item.areaId}, this.ServicoAreaInterdisciplinar).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Área Interdisciplinar já existe");
              this.areasLoading = false;
            } else { // Create it
              this.ServicoService.createMultipleData(this.ServicoAreaInterdisciplinar, [item], this.id, 'servicoId').then((x) => {
                this.UI.addToast("Área Interdisciplinar adicionada com sucesso");
                this.getAreasForServico();
              }).catch(error => {
                this.areasLoading = false;
                this.UI.addToast("Erro ao inserir área. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.areasLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete entrada/saida
  confirmDeleteArea = (x) => {
    let title = "Eliminar Área Interdisciplinar";
    let warning = "Tem a certeza que pretende remover esta área interdisciplinar?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeArea(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeArea = (x) => {
    this.areasLoading = true;
    // Find again area to delete so we can update it
    this.ServicoAreaInterdisciplinar.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((areaToRemove) => {
      // Only for mandatory existing multiple data
      this.ServicoAreaInterdisciplinar.count({
        fields: {id: true},
        where: {
          servicoId: this.id
        }
      }).$promise.then((res) => {
        if (res.count > 1) { // There are other areas still remaining

          // Remove data
          this.ServicoAreaInterdisciplinar.deleteById({
            id: areaToRemove.id,
          }).$promise.then((r) => {
            this.UI.addToast("Área interdisciplinar removida com sucesso");
            this.getAreasForServico();
          });

        } else { // No other areas exist, can't remove
          this.areasLoading = false;
          this.UI.showAlert("Não foi possível apagar a área interdisciplinar porque tem que haver pelo menos 1 registo para a prestação de serviço");
        }
      }).catch((error) => {
        console.log(error);
        this.UI.addToast("Não foi possível consultar orientação. Verifique a ligação");
        this.getAreasForServico();
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar área interdisciplinar. Verifique se ainda existe.");
      this.getAreasForServico();
    });
  };

  getAreasForServico = () => {
    this.areasLoading = true;
    let whereLiteral = {
      'ServicoAreaInterdisciplinar.servicoId': this.id
    };
    let where = {};
    Object.keys(this.optAreas.filter).forEach(f => {
      if (this.optAreas.filter[f])
        where[f] = this.optAreas.filter[f];
    });
    this.ServicoAreaInterdisciplinar.table({
      params: {
        fields: [
          'ServicoAreaInterdisciplinar.id as id',
          'ServicoAreaInterdisciplinar.servicoId as servicoId',
          'ServicoAreaInterdisciplinar.areaId as areaId',
          'ServicoAreaInterdisciplinar.dataCriacao as dataCriacao',
          'ServicoAreaInterdisciplinar.atualizadoa as atualizadoa',
          'ServicoAreaInterdisciplinar.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'AreaInterdisciplinar.id as auxAreaId',
          'AreaInterdisciplinar.designacao as auxAreaDesignacao'
        ],
        from: ['ServicoAreaInterdisciplinar', 'User', 'User', 'AreaInterdisciplinar'],
        references: [undefined, 'ServicoAreaInterdisciplinar.criadoPorId', 'ServicoAreaInterdisciplinar.atualizadoPorId', 'ServicoAreaInterdisciplinar.areaId'],
        aliases: [null, null, 'User2', null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optAreas.order,
        sort: this.optAreas.sort,
        limit: this.optAreas.items,
        skip: (this.optAreas.page - 1) * this.optAreas.items,
      }
    }).$promise.then(res => {
      let page = this.optAreas.page;
      let items = this.optAreas.items;

      let total = res.count;

      this.optAreas.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optAreas.start - 1 + items) >= total) {
        this.optAreas.end = total;
      } else {
        this.optAreas.end = Number.parseInt(this.optAreas.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.area = {
          id: x.auxAreaId,
          designacao: x.auxAreaDesignacao
        };
      });

      this.areas = res.data;
      this.optAreas.total = total;
      this.areasLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler áreas. Verifique a ligação");
    });
  };

  areaSort = keyname => {
    if (this.optAreas.order === keyname)
      this.optAreas.page = 1;
    this.optAreas.order = keyname;
    this.optAreas.sort = this.optAreas.sort === 'asc' ? 'desc' : 'asc';
    this.getAreasForServico();
  };

  areaItem = val => {
    this.optAreas.items = val;
    this.optAreas.page = 1;
    this.getAreasForServico();
  };

  areaPage = sum => {
    this.optAreas.page += sum;
    if (this.optAreas.page < 1)
      this.optAreas.page = 1;
    if (this.optAreas.page > Math.ceil(this.optAreas.total / this.optAreas.items))
      this.optAreas.page = Math.ceil(this.optAreas.total / this.optAreas.items);
    this.getAreasForServico();
  };

  viewArea = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./area.interdisciplinar.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Instituições
  instituicaoModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let instituicao = {};
    let auxInstituicaoSelection = undefined;
    if (edit && data != null) {
      instituicao = angular.copy(data);
      auxInstituicaoSelection = instituicao.instituicao;
    }
    let wait = this.UI.showWaiting();
    this.Instituicao.find({}).$promise.then((instituicoes) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/edit.instituicao.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Nova") + " Instituição envolvida";
          scope.instituicao = instituicao;
          scope.instituicoes = instituicoes;

          scope.auxInstituicao = {
            selected: auxInstituicaoSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível ler instituições. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um nova instituicao para servico
  addInstituicao = () => {
    this.instituicaoModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInstituicao && ok.instituicao) {
          this.instituicoesLoading = true;
          let item = angular.copy(ok.instituicao);
          item.instituicaoId = ok.auxInstituicao.selected.id;
          item.instituicao = angular.copy(ok.auxInstituicao.selected);
          // Check if instituicao is already there before creating
          this.ServicoService.usedPartialDataForModel({servicoId: this.id, instituicaoId: item.instituicaoId}, this.ServicoInstituicao).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Instituição já existe");
              this.instituicoesLoading = false;
            } else { // Create it
              this.ServicoService.createMultipleData(this.ServicoInstituicao, [item], this.id, 'servicoId').then((x) => {
                this.UI.addToast("Instituição adicionada com sucesso");
                this.getInstituicoesForServico();
              }).catch(error => {
                this.instituicoesLoading = false;
                this.UI.addToast("Erro ao inserir instituição. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.instituicoesLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete instituicao
  confirmDeleteInstituicao = (x) => {
    let title = "Eliminar Instituição";
    let warning = "Tem a certeza que pretende remover a participação desta instituição?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeInstituicao(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeInstituicao = (x) => {
    this.instituicoesLoading = true;
    // Find again instituicao to delete so we can update it
    this.ServicoInstituicao.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((instituicaoToRemove) => {

      // Remove data
      this.ServicoInstituicao.deleteById({
        id: instituicaoToRemove.id,
      }).$promise.then((r) => {
        this.UI.addToast("Instituição removida com sucesso");
        this.getInstituicoesForServico();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar instituição. Verifique se ainda existe.");
      this.getInstituicoesForServico();
    });
  };

  getInstituicoesForServico = () => {
    this.instituicoesLoading = true;
    let whereLiteral = {
      'ServicoInstituicao.servicoId': this.id
    };
    let where = {};
    Object.keys(this.optInstituicao.filter).forEach(f => {
      if (this.optInstituicao.filter[f])
        where[f] = this.optInstituicao.filter[f];
    });
    this.ServicoInstituicao.table({
      params: {
        fields: [
          'ServicoInstituicao.id as id',
          'ServicoInstituicao.servicoId as servicoId',
          'ServicoInstituicao.instituicaoId as instituicaoId',
          'ServicoInstituicao.dataCriacao as dataCriacao',
          'ServicoInstituicao.atualizadoa as atualizadoa',
          'ServicoInstituicao.criadoPorId as criadoPorId',
          'User.name as criadoPorName',
          'User2.name as atualizadoPorName',
          'Instituicao.id as auxInstituicaoId',
          'Instituicao.designacao as auxInstituicaoDesignacao',
          'Pais.nome as auxPaisNome'
        ],
        from: ['ServicoInstituicao', 'User', 'User', 'Instituicao', 'Pais'],
        referencesOrigin: [undefined, undefined, undefined, undefined, 'Pais.id'],
        references: [undefined, 'ServicoInstituicao.criadoPorId', 'ServicoInstituicao.atualizadoPorId', 'ServicoInstituicao.instituicaoId', 'Instituicao.paisId'],
        aliases: [null, null, 'User2', null, null],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optInstituicao.order,
        sort: this.optInstituicao.sort,
        limit: this.optInstituicao.items,
        skip: (this.optInstituicao.page - 1) * this.optInstituicao.items,
      }
    }).$promise.then(res => {
      let page = this.optInstituicao.page;
      let items = this.optInstituicao.items;

      let total = res.count;

      this.optInstituicao.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optInstituicao.start - 1 + items) >= total) {
        this.optInstituicao.end = total;
      } else {
        this.optInstituicao.end = Number.parseInt(this.optInstituicao.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.instituicao = {
          id: x.auxInstituicaoId,
          designacao: x.auxInstituicaoDesignacao,
          pais: x.auxPaisNome,
        };
      });

      this.instituicoes = res.data;
      this.optInstituicao.total = total;
      this.instituicoesLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler instituições. Verifique a ligação");
    });
  };

  instituicaoSort = keyname => {
    if (this.optInstituicao.order === keyname)
      this.optInstituicao.page = 1;
    this.optInstituicao.order = keyname;
    this.optInstituicao.sort = this.optInstituicao.sort === 'asc' ? 'desc' : 'asc';
    this.getInstituicoesForServico();
  };

  instituicaoItem = val => {
    this.optInstituicao.items = val;
    this.optInstituicao.page = 1;
    this.getInstituicoesForServico();
  };

  instituicaoPage = sum => {
    this.optInstituicao.page += sum;
    if (this.optInstituicao.page < 1)
      this.optInstituicao.page = 1;
    if (this.optInstituicao.page > Math.ceil(this.optInstituicao.total / this.optInstituicao.items))
      this.optInstituicao.page = Math.ceil(this.optInstituicao.total / this.optInstituicao.items);
    this.getInstituicoesForServico();
  };

  viewInstituicao = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./instituicao.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).isValid() ? moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.data.atualizadoa = moment($scope.data.atualizadoa).isValid() ? moment($scope.data.atualizadoa).format('DD/MM/YYYY HH:mm:ss') : null;
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };


  // Impactos
  // Edit Impacto Ambiental, Económico, Social
  editImpactos = () => {
    let options = {
      size: 'lg',
      template: require('./impactos.dialog.html'),
      controller: ['$scope', ($scope) => {
        $scope.label = "Editar Impacto Ambiental, Económico, Social";
        $scope.impacto = angular.copy(this.data.impacto);
        $scope.simnao = this.simnao;

        $scope.auxImpactoAmbiental = {
          selected: $scope.impacto.ambiental ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoEconomico = {
          selected: $scope.impacto.economico ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoSocial = {
          selected: $scope.impacto.social ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };
        $scope.auxImpactoPolicyInfluence = {
          selected: $scope.impacto.policyInfluence ? $scope.simnao.find(x => x.value === 1) : $scope.simnao.find(x => x.value === 0),
          infiniteScroll: {numToAdd: 20, currentItems: 20}
        };

        // Infinite Scroll magic
        $scope.addMoreItems = (infiniteScroll) => {
          infiniteScroll.currentItems += infiniteScroll.numToAdd;
        };

        $scope.ok = () => {
          $scope.$close($scope);
        };

        $scope.cancel = () => $scope.$dismiss('cancel');
      }]
    };

    this.UI.showDialog(options).then(ok => {
      this.loaded = false;

      // Ambiental
      if (ok.auxImpactoAmbiental.selected.value) {
        this.data.impacto.ambiental = ok.impacto.ambiental;
      } else {
        this.data.impacto.ambiental = null;
      }
      // Económico
      if (ok.auxImpactoEconomico.selected.value) {
        this.data.impacto.economico = ok.impacto.economico;
      } else {
        this.data.impacto.economico = null;
      }
      // Social
      if (ok.auxImpactoSocial.selected.value) {
        this.data.impacto.social = ok.impacto.social;
      } else {
        this.data.impacto.social = null;
      }
      // Policy influence
      if (ok.auxImpactoPolicyInfluence.selected.value) {
        this.data.impacto.policyInfluence = ok.impacto.policyInfluence;
      } else {
        this.data.impacto.policyInfluence = null;
      }

      this.data.impacto.observacoes = ok.impacto.observacoes || null;

      this.data.impacto.criadoPorId = this.user.id;
      this.data.impacto.dataCriacao = moment().format();

      this.Impacto.upsert(this.data.impacto).$promise.then(() => {
        this.UI.addToast("Impactos atualizados com sucesso");
        this.loadData();
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao atualizar impactos. Verifique a ligação");
        this.loaded = true;
      });
    });
  };

  //Impactos ODS
  impactosOdsModalOptions = (data, edit) => {
    let defer = this.$q.defer();

    let ods = {};
    let auxOdsSelection = undefined;
    if (edit && data != null) {
      ods = angular.copy(data);
      auxOdsSelection = ods.ods;
    }
    let wait = this.UI.showWaiting();
    this.Ods.find({}).$promise.then((externalData) => {
      wait.close();
      defer.resolve({
        size: 'lg',
        template: require('./../new/impacto.dialog.html'),
        controller: ['$dialog', '$scope', (dialog, scope) => {
          scope.label = (edit ? "Editar" : "Novo") + " Impacto ODS";
          scope.ods = ods;
          scope.externalData = externalData;
          scope.tipo = 'ODS';

          scope.auxOds = {
            selected: auxOdsSelection,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          scope.ok = () => {
            dialog.close(scope);
          };

          scope.cancel = () => {
            dialog.dismiss('cancel');
          };
        }]
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler Impactos ODS. Verifique a sua ligação");
      defer.reject();
    });
    return defer.promise;
  };

  // Adicionar um novo ODS para impacto
  addImpactoOds = () => {
    this.impactosOdsModalOptions(null, false).then(options => {
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxOds && ok.ods) {
          this.impactosOdsLoading = true;
          let item = angular.copy(ok.ods);
          item.odsId = ok.auxOds.selected.id;
          item.ods = angular.copy(ok.auxOds.selected);
          // Check if ODS is already there before creating
          this.ServicoService.usedPartialDataForModel({impactoId: this.data.impactoId, odsId: item.odsId}, this.ImpactoOds).then(res => {
            if (res.count > 0) { // Already exists
              this.UI.addToast("Impacto ODS já existe");
              this.impactosOdsLoading = false;
            } else { // Create it
              this.ServicoService.createMultipleData(this.ImpactoOds, [item], this.data.impactoId, 'impactoId').then(() => {
                this.UI.addToast("ODS adicionado com sucesso");
                this.getImpactosOdsForImpacto();
              }).catch(error => {
                this.impactosOdsLoading = false;
                this.UI.addToast("Erro ao inserir ODS. Verifique a ligação");
                console.log(error);
              });
            }
          }).catch((error) => {
            this.impactosOdsLoading = false;
            this.UI.addToast("Erro de criação. Verifique a ligação.");
            console.log(error);
          });
        }
      });
    }).catch(() => {}); // Already dealt with upstream
  };

  // Ask confirmation to delete ODS
  confirmDeleteImpactoOds = (x) => {
    let title = "Eliminar Impacto ODS";
    let warning = "Tem a certeza que pretende remover este impacto ODS?";
    let instance = this.UI.showDialog({
      size: 'md',
      template: require('../../interface/modals/delete-selected.html'),
      controller: ['$scope', function ($scope) {
        $scope.title = title;
        $scope.message = warning;
        $scope.ok = function () {
          $scope.$close();
        };
        $scope.cancel = function () {
          $scope.$dismiss('cancel');
        };
      }]
    });

    instance.then(() => {
      this.removeImpactoOds(x);
    }, (err) => {
      if (err !== 'cancel' && err !== 'escape key press' && err !== 'backdrop click')
        console.log(err);
    })
  };

  removeImpactoOds = (x) => {
    this.impactosOdsLoading = true;
    // Find again impacto ods to delete, so we can update it
    this.ImpactoOds.findOne({
      filter: {
        where: {
          id: x.id
        }
      }
    }).$promise.then((impactoOdsToRemove) => {
      // Only for mandatory existing multiple data

      // Remove data
      this.ImpactoOds.deleteById({
        id: impactoOdsToRemove.id,
      }).$promise.then(() => {
        this.UI.addToast("Impacto ODS removido com sucesso");
        this.getImpactosOdsForImpacto();
      });

    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Não foi possível eliminar impacto ODS. Verifique se ainda existe.");
      this.getImpactosOdsForImpacto();
    });
  };

  getImpactosOdsForImpacto = () => {
    this.impactosOdsLoading = true;
    let whereLiteral = {
      'ImpactoOds.impactoId': this.data.impactoId
    };
    let where = {};
    Object.keys(this.optImpactosOds.filter).forEach(f => {
      if (this.optImpactosOds.filter[f])
        where[f] = this.optImpactosOds.filter[f];
    });
    this.ImpactoOds.table({
      params: {
        fields: [
          'ImpactoOds.id as id',
          'ImpactoOds.impactoId as impactoId',
          'ImpactoOds.odsId as odsId',
          'ImpactoOds.dataCriacao as dataCriacao',
          'User.name as criadoPor',
          'Ods.id as auxOdsId',
          'Ods.designacao as auxOdsDesignacao'
        ],
        from: ['ImpactoOds', 'User', 'Ods'],
        references: [undefined, 'ImpactoOds.criadoPorId', 'ImpactoOds.odsId'],
        where: where,
        whereLiteral: whereLiteral,
        order: this.optImpactosOds.order,
        sort: this.optImpactosOds.sort,
        limit: this.optImpactosOds.items,
        skip: (this.optImpactosOds.page - 1) * this.optImpactosOds.items,
      }
    }).$promise.then(res => {
      let page = this.optImpactosOds.page;
      let items = this.optImpactosOds.items;

      let total = res.count;

      this.optImpactosOds.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.optImpactosOds.start - 1 + items) >= total) {
        this.optImpactosOds.end = total;
      } else {
        this.optImpactosOds.end = Number.parseInt(this.optImpactosOds.start - 1 + items);
      }

      // Process sub-data
      res.data.forEach(x => {
        x.ods = {
          id: x.auxOdsId,
          designacao: x.auxOdsDesignacao
        };
      });

      this.impactosOds = res.data;
      this.optImpactosOds.total = total;
      this.impactosOdsLoading = false;
    }).catch((e) => {
      console.log(e);
      this.UI.addToast("Não foi possível ler ODS. Verifique a ligação");
    });
  };

  impactoOdsSort = keyname => {
    if (this.optImpactosOds.order === keyname)
      this.optImpactosOds.page = 1;
    this.optImpactosOds.order = keyname;
    this.optImpactosOds.sort = this.optImpactosOds.sort === 'asc' ? 'desc' : 'asc';
    this.getImpactosOdsForImpacto();
  };

  impactoOdsItem = val => {
    this.optImpactosOds.items = val;
    this.optImpactosOds.page = 1;
    this.getImpactosOdsForImpacto();
  };

  impactoOdsPage = sum => {
    this.optImpactosOds.page += sum;
    if (this.optImpactosOds.page < 1)
      this.optImpactosOds.page = 1;
    if (this.optImpactosOds.page > Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items))
      this.optImpactosOds.page = Math.ceil(this.optImpactosOds.total / this.optImpactosOds.items);
    this.getImpactosOdsForImpacto();
  };

  viewImpactoOds = x => {
    this.UI.showDialog({
      size: 'md',
      template: require('./impacto.ods.info.dialog.html'),
      controller: ['$scope', function ($scope) {
        $scope.data = angular.copy(x);
        $scope.data.dataCriacao = moment($scope.data.dataCriacao).format('DD/MM/YYYY HH:mm:ss');
        $scope.fechar = function () {
          $scope.$close();
        };
      }]
    });
  };

  // Permissions
  // read: (ownPermission, allowAll, adminPermission, users)
  // edit: (ownPermission, allowOwn, adminPermission, users)
  canReadGeneral = () => this.ServicoService.canRead('servicoRead', true, 'servicoReadAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditGeneral = () => this.ServicoService.canEdit('servicoEdit', true, 'servicoEditAny', this.ServicoService.getParticipanteUserId(this.data));

  canReadAdicional = () => this.ServicoService.canRead('servicoReadAdicional', true, 'servicoReadAdicionalAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditAdicional = () => this.ServicoService.canEdit('servicoEditAdicional', true, 'servicoEditAdicionalAny', this.ServicoService.getParticipanteUserId(this.data));

  canReadParticipante = () => this.ServicoService.canRead('servicoReadParticipante', true, 'servicoReadParticipanteAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditParticipante = () => this.ServicoService.canEdit('servicoEditParticipante', true, 'servicoEditParticipanteAny', this.ServicoService.getParticipanteUserId(this.data));

  canReadInstituicao = () => this.ServicoService.canRead('servicoReadInstituicao', true, 'servicoReadInstituicaoAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditInstituicao = () => this.ServicoService.canEdit('servicoEditInstituicao', true, 'servicoEditInstituicaoAny', this.ServicoService.getParticipanteUserId(this.data));

  canReadAreaInterdisciplinar = () => this.ServicoService.canRead('servicoReadAreaInterdisciplinar', true, 'servicoReadAreaInterdisciplinarAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditAreaInterdisciplinar = () => this.ServicoService.canEdit('servicoEditAreaInterdisciplinar', true, 'servicoEditAreaInterdisciplinarAny', this.ServicoService.getParticipanteUserId(this.data));

  canReadImpacto = () => this.ServicoService.canRead('servicoReadImpacto', true, 'servicoReadImpactoAny', this.ServicoService.getParticipanteUserId(this.data));
  canEditImpacto = () => this.ServicoService.canEdit('servicoEditImpacto', true, 'servicoEditImpactoAny', this.ServicoService.getParticipanteUserId(this.data));

}

ServicoDetailsController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'ServicoService', 'Servico', 'ServicoParticipante', 'ServicoInstituicao', 'ServicoAreaInterdisciplinar', 'EntidadeFinanciadora', 'Investigador', 'Instituicao', 'AreaInterdisciplinar', 'Setor', 'Impacto', 'ImpactoOds', 'Ods', 'Pais'];
